export default __webpack_public_path__ + "static/media/btn-apple-black-bg.1b8b7136.svg";